import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const StyledPagination = styled.div`
    background-color: ${colorsPalettes.carbon["0"]};
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    padding: 8px 0;
`;
